import { forwardRef } from "react";

function Root(props, ref) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="black" />
      <path
        d="M24 8C15.16 8 8 15.1117 8 23.8921C8 30.9243 12.58 36.8639 18.94 38.9696C19.74 39.1087 20.04 38.6319 20.04 38.2148C20.04 37.8373 20.02 36.5858 20.02 35.2549C16 35.9899 14.96 34.2815 14.64 33.3876C14.46 32.9307 13.68 31.5202 13 31.1428C12.44 30.8448 11.64 30.1098 12.98 30.09C14.24 30.0701 15.14 31.2421 15.44 31.7189C16.88 34.1226 19.18 33.4472 20.1 33.03C20.24 31.997 20.66 31.3017 21.12 30.9044C17.56 30.5071 13.84 29.1364 13.84 23.0577C13.84 21.3295 14.46 19.8992 15.48 18.7867C15.32 18.3894 14.76 16.7605 15.64 14.5753C15.64 14.5753 16.98 14.1582 20.04 16.2043C21.32 15.8467 22.68 15.6679 24.04 15.6679C25.4 15.6679 26.76 15.8467 28.04 16.2043C31.1 14.1383 32.44 14.5753 32.44 14.5753C33.32 16.7605 32.76 18.3894 32.6 18.7867C33.62 19.8992 34.24 21.3096 34.24 23.0577C34.24 29.1563 30.5 30.5071 26.94 30.9044C27.52 31.401 28.02 32.3546 28.02 33.8445C28.02 35.97 28 37.6784 28 38.2148C28 38.6319 28.3 39.1286 29.1 38.9696C35.6129 36.7858 39.9982 30.7197 40 23.8921C40 15.1117 32.84 8 24 8Z"
        fill="white"
      />
    </svg>
  );
}
const Github = forwardRef(Root);
export default Github;
